export enum ACTIVITY_STOCK_METRIC_ENUM {
  ACTIVITY_STOCK_HISTOGRAM = 'activity-stock-histogram',
  ACTIVITY_STOCK_REDUCTION = 'activity-stock-reduction',
  ACTIVITY_STOCK_TOP_USER = 'activity-stock-top-user',
}

export enum PRODUCT_STOCK_METRIC_ENUM {
  PRODUCT_STOCK_SUMMARY = 'product-stock-summary',
}
